import { AI_ENDPOINTS } from 'features/ai-generators/constants';
import { SECONDARY_API_CLIENT } from 'services/API';
import { FeatureFlags } from 'UI/constants/featureFlags';
import { hasFeatureFlag } from 'UI/utils';

export const generateCandidatePresentation = async data => {
  const endpoint = hasFeatureFlag(FeatureFlags.AIPresentationMakerV2Endpoints)
    ? AI_ENDPOINTS.candidatesPresentationMakerV2
    : AI_ENDPOINTS.candidatesPresentationMaker;
  return SECONDARY_API_CLIENT.post(endpoint, data);
};

export const generateJobOrderPresentation = async data => {
  const endpoint = hasFeatureFlag(FeatureFlags.AIPresentationMakerV2Endpoints)
    ? AI_ENDPOINTS.jobOrdersPresentationMakerV2
    : AI_ENDPOINTS.jobOrdersPresentationMaker;
  return SECONDARY_API_CLIENT.post(endpoint, data);
};

export const ratePresentationMakerGenerated = async ({ id, score }) => {
  return SECONDARY_API_CLIENT.post(AI_ENDPOINTS.ratePresentationMakerGenerated, { id, score });
};
